import { useStyles } from "./styles";
import { LeftHeader } from "./Left/index";
import { RightHeader } from "./Right/index";
import Fade from "@mui/material/Fade";
import Stack from "@mui/material/Stack";
import SideBarMenu from "./SideBar/index";
import { AppBar } from "@mui/material";
//import Box from "@mui/material/Box";

type HeaderProps = {
  children: React.ReactNode;
};

export function Header({ children }: HeaderProps) {
  const styles = useStyles();

  return (
    <div style={{ width: "100%" }}>
      <AppBar
        id="header-block"
        sx={{
          ...(window.location.href.includes("initial-settings")
            ? { display: "none" }
            : { display: "flex", flexDirection: "row" }),
        }}
        color={"inherit"}
        classes={{ root: styles.root }}
      >
        <LeftHeader />
        <RightHeader />
      </AppBar>
      <Stack direction="row">
        <SideBarMenu test-id="grid-page-sidebar" />
        <div test-id="grid-page-content" className={styles.content}>
          <Fade
            test-id="fade-page-content"
            in
            timeout={{ exit: 0, enter: 1 * 500 }}
            appear
            unmountOnExit
            style={{ flex: 1 }}
          >
            <div style={{ marginTop: "50px" }} test-id="page-content">
              {children}
            </div>
          </Fade>
        </div>
      </Stack>
    </div>
  );
}
